import * as expressionNode from '../../../node'

/**
 * For some expressions, we don't need value nodes that have no adjacent
 * non-value nodes (e.g. < or >)
 *
 * @example
 * // 1 < 2 < X < 3 < 4 < 5 < Y
 * // ==>
 * // 2 < X < 3 < 5 < Y
 */
export function removeIsolatedValueNodes(
  nodes: readonly expressionNode.Node[],
): expressionNode.Node[] {
  const finalNodes: expressionNode.Node[] = []
  let lastAdded = -1
  // We go through each node...
  for (let i = 0; i < nodes.length - 1; i++) {
    // And when we get to a non-value node...
    if (!expressionNode.ForValue.isForValue(nodes[i])) {
      // We add the node before this node, if there is one and it has not
      // already been added
      const start = Math.max(i - 1, lastAdded + 1, 0)
      // We add the node after this node, if there is one
      const end = Math.min(nodes.length - 1, i + 1)
      // And of course we add this node no matter what
      for (i = start; i <= end; i++) {
        // NOTE: it is important that the above for loop uses `i` so that
        // when we finish, the outer for loop will not go back over the
        // nodes we just added
        finalNodes.push(nodes[i])
        lastAdded = i
      }
    }
  }
  return finalNodes
}
